<template>
  <div class="container mt-2">
    <!-- <page-404 v-if="document_not_found" :message="$t('document not found')" />
    <page-500 v-if="document_expired" :message="$t('document expired')" />
    <page-200
      v-if="document_signed"
      :message="$t('thank you for completing your request')"
    /> -->
    <!-- <h3 class="title is-4 has-text-centered mb-0">
      <span class="icon">
        <i class="fa fa-file-signature"></i>
      </span>
      {{ $t("savings account request") }}
    </h3> -->

    <p v-if="error" class="notification is-danger" v-html="error"></p>
    <sms-code-modal
      ref="sms_code_modal"
      @verification-completed="onVerificationCompleted"
    />
    <email-code-modal
      ref="email_code_modal"
      @verification-completed="onVerificationCompleted"
    />
    <dpi-modal ref="dpi_modal" @verification-completed="onDpiVerified" />
  </div>
</template>

<script>
import {
  warning_message,
  get,
  generate_error_message_text,
  post,
  format_date,
  drive_static_file_url,
} from "@/utils";
import moment from "moment";
import Page404 from "@/components/404/Index.vue";
import Page500 from "@/components/500/Index.vue";
import Page200 from "@/components/200/Index.vue";
import SmsCodeModal from "./personal-savings-complete-components/sms-code-method-modal/Index.vue";
import EmailCodeModal from "./personal-savings-complete-components/email-code-method-modal/Index.vue";
import DpiModal from "./personal-savings-complete-components/dpi-method-modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "PersonalSavingsAccountRequestPerform",
  components: {
    Page404,
    Page500,
    Page200,
    SmsCodeModal,
    EmailCodeModal,
    DpiModal,
    GenericDropdown,
  },
  data() {
    return {
      error: "",
      request: null,
      meta: {},
    };
  },
  methods: {
    format_date,
    load_request(uuid) {
      let v = this;
      v.$root.loader(true);
      get("/account-request/personal-savings/complete/perform", { uuid: uuid })
        .then((response) => {
          if (
            response &&
            response.settings &&
            response.settings.security_method
          ) {
            v.request = response;
            v.perform_security_method(
              response.settings.security_method,
              response
            )
              .then(() => {
                console.log("Security method completed successfully");
              })
              .catch((error) => {
                v.error = generate_error_message_text(error);
                console.error("Security method failed", error);
              });
          } else {
            v.start();
          }
        })
        .catch((error) => {
          // if (error.status === 404) {
          //   v.document_not_found = true;
          // } else if (
          //   error.status === 500 &&
          //   error.data.includes("Request has expired")
          // ) {
          //   v.document_expired = true;
          //   // } else if (error.status === 400 && error.data.includes("completed")) {
          //   //   v.document_signed = true;
          // } else if (
          //   error.status === 500 &&
          //   error.data.includes("Documentation completed")
          // ) {
          //   v.document_signed = true;
          // } else {
          console.error(error);
          v.error = generate_error_message_text(error);
          //   // error_message(v.error);
          // }
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    perform_security_method(method, account_request) {
      let v = this;
      return new Promise((resolve, reject) => {
        if (method === "none") {
          console.log("No security method to perform");
          v.start();
          resolve();
        } else if (method === "email-code") {
          v.$refs.email_code_modal.show(account_request);
        } else if (method === "sms-code") {
          v.$refs.sms_code_modal.show(account_request);
        } else if (method === "whatsapp-code") {
          console.log("Performing WhatsApp code verification");
          reject("WhatsApp code verification is not implemented yet.");
        } else if (method === "dpi") {
          v.$refs.dpi_modal.show(account_request);
        } else {
          console.error("Unknown security method:", method);
          reject(`Unknown security method: ${method}`);
        }
      });
    },
    onVerificationCompleted() {
      let v = this;
      v.start();
      // this.$router.push({
      //   path: `/account-request/personal-savings/complete/${this.$route.params.uuid}`,
      // });
    },
    onDpiVerified() {
      let v = this;
      v.start();
      // this.$router.push({
      //   path: `/account-request/personal-savings/complete/${this.$route.params.uuid}`,
      // });
    },
    start() {
      let v = this;
      console.log("Starting account request completion process", v.request);
      let flow = v.request.settings.flow;
      let status = v.request.status;
      if (["unopened", "in-progress"].includes(status)) {
        v.$router.push({
          path: `/account-request/personal-savings/complete/${v.request.uuid}`,
        });
      } else if (status === "formulary-completed") {
        if (flow === "capture-documentation-verification") {
          v.$router.push({
            path: `/account-request/personal-savings/documentation/${v.request.uuid}`,
          });
        } else if (flow === "capture-verification-documentation") {
          v.$router.push({
            path: `/account-request/personal-savings/verification/${v.request.uuid}`,
          });
        } else {
          console.error("Unknown flow:", flow);
          warning_message(
            v.$t("the request is in an unknown state, please contact support")
          );
        }
      } else if (status === "documentation-completed") {
        if (flow === "capture-documentation-verification") {
          v.$router.push({
            path: `/account-request/personal-savings/verification/${v.request.uuid}`,
          });
        } else if (flow === "capture-verification-documentation") {
          v.$router.push({
            path: `/account-request/personal-savings/process-finished`,
          });
        } else {
          console.error("Unknown flow:", flow);
          warning_message(
            v.$t("the request is in an unknown state, please contact support")
          );
        }
      } else if (status === "onfido-completed") {
        if (flow === "capture-documentation-verification") {
          v.$router.push({
            path: `/account-request/personal-savings/process-finished`,
          });
        } else if (flow === "capture-verification-documentation") {
          v.$router.push({
            path: `/account-request/personal-savings/documentation/${v.request.uuid}`,
          });
        } else {
          console.error("Unknown flow:", flow);
          warning_message(
            v.$t("the request is in an unknown state, please contact support")
          );
        }
      } else {
        console.log("request is already opened", v.request);
        warning_message(
          v.$t("the request is in an unknown state, please contact support")
        );
      }

      // v.request = request;
      // v.meta = {
      //   client_dpi: request.destinatary.renap_data.DPI,
      //   client_email: request.destinatary.email,
      //   client_phone: request.destinatary.phone,
      //   status: request.status,
      //   admin_notes: request.admin_notes,
      //   settings: request.settings,
      // };
    },
  },
  mounted() {
    let uuid = this.$route.params.uuid;
    if (uuid) this.load_request(uuid);
    else error = this.$t("invalid request id");
  },
};
</script>

<style scoped></style>
